// TODO: add all top writers, fetched and rendered here.

import PropTypes from 'prop-types';
import React, { memo, useEffect, useState } from 'react';

import TopWriters from '@/src/advocacy/components/state/TopWriters';
import Heading from '@/src/shared/components/Heading';
import { space } from '@/styles';
import request from '@/utils/axios';

const industryTypes = [
  'Commercial Auto',
  'Commercial Multi-Peril',
  'Homeowners Multi-Peril',
  'Medical Malpractice',
  'Other Liability',
  'Private Passenger Auto',
  'Total Property Casualty',
  'Workers Compensation',
];

const AllTopWriters = memo(function AllTopWriters(props) {
  const { statecode } = props;
  const [topWritersData, setTopWritersData] = useState([]);

  useEffect(() => {
    if (!statecode) return;
    (async function mounted() {
      try {
        const responses = await Promise.all(
          industryTypes.map(type => {
            return request({
              url: 'statesnapshot/topwriters',
              params: {
                stateCode: statecode,
                industryType: type,
              },
            });
          })
        );
        setTopWritersData(responses.map(r => r.data.TopWriters));
      } catch (error) {
        console.log(error);
        setTopWritersData([]);
      }
    })();
  }, [statecode]);

  return (
    <>
      {topWritersData.map(tr => (
        <div css={space.m.b32} key={tr[0].IndustryType}>
          <div className="pagebreak" />
          <TopWriters writersData={tr} />
        </div>
      ))}
    </>
  );
});

AllTopWriters.propTypes = {
  statecode: PropTypes.string,
};

AllTopWriters.defaultProps = {
  statecode: '',
};

export default AllTopWriters;
